module.exports = __webpack_public_path__ + "static/hero-0f46dad83656be7bd6e2bd7cdcd11a22.png";